import { render, staticRenderFns } from "./locTypeMultipleTag.vue?vue&type=template&id=51cb0b6a&"
import script from "./locTypeMultipleTag.vue?vue&type=script&lang=js&"
export * from "./locTypeMultipleTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports